"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constantes_1 = require("./constantes");
var pieces_1 = require("./pieces");
function getDefaultBoardState() {
    var botColor = constantes_1.White;
    var topColor = constantes_1.Black;
    return {
        whoseTurn: constantes_1.White,
        pieces: [
            /**
             * bottom
             */
            {
                type: pieces_1.Rook.key,
                x: 0,
                y: 0,
                color: botColor,
            },
            {
                type: pieces_1.Knight.key,
                x: 1,
                y: 0,
                color: botColor,
            },
            {
                type: pieces_1.Bishop.key,
                x: 2,
                y: 0,
                color: botColor,
            },
            {
                type: botColor === constantes_1.White ? pieces_1.King.key : pieces_1.Queen.key,
                x: 3,
                y: 0,
                color: botColor,
            },
            {
                type: botColor === constantes_1.White ? pieces_1.Queen.key : pieces_1.King.key,
                x: 4,
                y: 0,
                color: botColor,
            },
            {
                type: pieces_1.Bishop.key,
                x: 5,
                y: 0,
                color: botColor,
            },
            {
                type: pieces_1.Knight.key,
                x: 6,
                y: 0,
                color: botColor,
            },
            {
                type: pieces_1.Rook.key,
                x: 7,
                y: 0,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 0,
                y: 1,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 1,
                y: 1,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 2,
                y: 1,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 3,
                y: 1,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 4,
                y: 1,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 5,
                y: 1,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 6,
                y: 1,
                color: botColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 7,
                y: 1,
                color: botColor,
            },
            /**
             * top
             */
            {
                type: pieces_1.Rook.key,
                x: 0,
                y: 7,
                color: topColor,
            },
            {
                type: pieces_1.Knight.key,
                x: 1,
                y: 7,
                color: topColor,
            },
            {
                type: pieces_1.Bishop.key,
                x: 2,
                y: 7,
                color: topColor,
            },
            {
                type: botColor === constantes_1.White ? pieces_1.King.key : pieces_1.Queen.key,
                x: 3,
                y: 7,
                color: topColor,
            },
            {
                type: botColor === constantes_1.White ? pieces_1.Queen.key : pieces_1.King.key,
                x: 4,
                y: 7,
                color: topColor,
            },
            {
                type: pieces_1.Bishop.key,
                x: 5,
                y: 7,
                color: topColor,
            },
            {
                type: pieces_1.Knight.key,
                x: 6,
                y: 7,
                color: topColor,
            },
            {
                type: pieces_1.Rook.key,
                x: 7,
                y: 7,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 0,
                y: 6,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 1,
                y: 6,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 2,
                y: 6,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 3,
                y: 6,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 4,
                y: 6,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 5,
                y: 6,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 6,
                y: 6,
                color: topColor,
            },
            {
                type: pieces_1.Pawn.key,
                x: 7,
                y: 6,
                color: topColor,
            },
        ],
    };
}
exports.default = getDefaultBoardState;
function getRandomBoardState() {
    var state = getDefaultBoardState();
    // on place les pieces aléatoirement
    state.pieces.forEach(function (piece) {
        var newPos = getRandomPos(piece);
        moveAndSwap(piece, newPos.x, newPos.y, state.pieces);
    });
    // on vérifie que les 2 fous d'un même joueur
    // ne sont pas sur une case de même couleur
    var whiteBishop = -1;
    var blackBishop = -1;
    state.pieces.forEach(function (piece) {
        if (piece.type === pieces_1.Bishop.key) {
            var color = piece.x % 2 === piece.y % 2 ? 0 : 1;
            var matesColor = piece.color === constantes_1.White ? whiteBishop : blackBishop;
            if (color === matesColor) {
                // les 2 fous sont sur une case de même couleur, on décale le 2e d'une case
                moveAndSwap(piece, (piece.x + 1) % constantes_1.WIDTH, piece.y, state.pieces);
            }
            if (piece.color === constantes_1.White) {
                whiteBishop = color;
            }
            else {
                blackBishop = color;
            }
        }
    });
    return state;
}
exports.getRandomBoardState = getRandomBoardState;
function moveAndSwap(piece, x, y, pieces) {
    var swap = getPieceAt(pieces, x, y);
    if (swap) {
        swap.x = piece.x;
        swap.y = piece.y;
    }
    piece.x = x;
    piece.y = y;
}
function getPieceAt(pieces, x, y) {
    // pieces est de type any parce que TypeScript ne semble pas être au courant que Array.find existe depuis 150 ans
    return pieces.find(function (piece) { return piece.x === x && piece.y === y; });
}
function getRandomPos(piece) {
    var out = {
        x: Math.floor(Math.random() * constantes_1.WIDTH),
        y: Math.floor(Math.random() * 3),
    };
    if (piece.color === constantes_1.Black) {
        out.y = constantes_1.HEIGHT - 1 - out.y;
    }
    return out;
}



/*****************
 ** WEBPACK FOOTER
 ** ../brchess-core/dist/state.js
 ** module id = 8
 ** module chunks = 0
 **/